import { Component, Inject, OnInit } from '@angular/core';
import { environment } from './../../../environments/environment';
import { IAppConfig, SupportTheme } from './../../core/config/app-config.model';
import { APP_CONFIG } from './../../core/config/app-config.service';
import { AppConstants } from '../../AppConstants';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent implements OnInit {

  isShowCheckItNow = sessionStorage.getItem('hide_check_it_now') !== '1'

  constructor(
    @Inject(APP_CONFIG) protected config: IAppConfig,
  ) { }

  versionName = AppConstants.versionName
  theme: SupportTheme;

  ngOnInit(): void {
    this.theme = this.config.themeDefault;
    this.isShowCheckItNow = false;
    this.updateBanner();
  }

  updateBanner(){
    if(this.isShowCheckItNow){
      document.querySelector('body').classList.add('show-bottom-banner');
    }
    else{
      document.querySelector('body').classList.remove('show-bottom-banner');
    }
  }

  hideCheckItNow(){
    this.isShowCheckItNow = false;
    sessionStorage.setItem('hide_check_it_now', '1');
    this.updateBanner();
  }

  getLinkPrivacyPolicy() {
    if (this.config.LogoHeaderLink) {
      return `${this.config.LogoHeaderLink}/privacy-policy`;
    }

    return '';
  }
}
